import { Button, Flex, VStack } from '@chakra-ui/react';
import { Form, Formik } from 'formik';
import React, { useState } from 'react';
import { FileWithPath } from 'react-dropzone';
import { mixed, object } from 'yup';

import UploadReceivablesCSVDropzone from './UploadReceivablesCSVDropzone';

type Props = {
  onClose: () => void;
  handleFile: (file: File) => void;
};
export const UploadReceivablesCSVForm = ({ onClose, handleFile }: Props) => {
  const [loading, setLoading] = useState(false);

  return (
    <Formik
      onSubmit={async (values) => {
        try {
          if (values && values.file) {
            handleFile(values.file);
          }
        } catch (err) {
          setLoading(false);
          throw err;
        }
        setLoading(false);
        onClose();
      }}
      validationSchema={object().shape({
        file: mixed(),
      })}
      initialValues={{
        file: null,
      }}
      validateOnChange={false}
    >
      {({ handleSubmit, setFieldValue, values }) => (
        <Form onSubmit={handleSubmit}>
          <VStack spacing="10px">
            <UploadReceivablesCSVDropzone
              isDisabled={loading}
              setFieldValue={(value: FileWithPath) =>
                setFieldValue(`file`, value)
              }
            />
            <Flex padding-top="5px" justifyContent="center">
              <Button
                isDisabled={!values.file}
                isLoading={loading}
                type="submit"
              >
                Submit
              </Button>
            </Flex>
          </VStack>
        </Form>
      )}
    </Formik>
  );
};
